import { Reveal, Eyebrow } from "@/components/Reveal";
import { ValueContrast } from "@/components/ValueContrast";
import { LibraryMosaic } from "@/components/LibraryMosaic";
import { SaleNote } from "@/components/SaleNote";
import { BuyButton } from "@/components/Buttons";
import { OWNER_PLAN, OWNER_LIBRARY } from "@/data/offer";

export const OwnerPlan = () => (
  <section id="wlascicielki" data-testid="owner-plan-section" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
        <Reveal className="lg:col-span-6">
          <Eyebrow>Abonament właścicielski</Eyebrow>
          <h2 className="font-display mt-5 text-4xl font-medium leading-[1.02] tracking-[-0.02em] text-ink sm:text-5xl lg:text-6xl">
            Abonament dla właścicielki / właściciela szkoły
          </h2>
          <p className="mt-6 max-w-[54ch] text-base leading-relaxed text-ink/65 sm:text-lg">
            Materiały o prowadzeniu szkoły językowej jako organizacji: od planu operacyjnego na rok, przez sekretariat
            i procesy, po współpracę z firmami. Dla jednej osoby zarządzającej szkołą.
          </p>

          <div className="mt-12">
            <LibraryMosaic
              items={OWNER_LIBRARY.flatMap((g) => g.items)}
              caption="6 produktów w bibliotece właścicielskiej"
              testId="owner-library-mosaic"
              gridClass="grid-cols-3 gap-2 sm:gap-3"
            />
          </div>

          <div className="mt-12 border-t border-ink/15">
            {OWNER_LIBRARY.map((g) => (
              <div key={g.category} className="grid grid-cols-1 gap-2 border-b border-ink/15 py-5 sm:grid-cols-[200px_1fr] sm:gap-6">
                <h3 className="text-[11px] font-semibold uppercase tracking-[0.18em] text-red">{g.category}</h3>
                <ul className="space-y-1.5">
                  {g.items.map((p) => (
                    <li key={p.name}>
                      <a
                        href={p.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`owner-product-link-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                        className="font-display text-xl text-ink underline-offset-4 hover:text-red hover:underline"
                      >
                        {p.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15} className="lg:col-span-5 lg:col-start-8">
          <div className="sticky top-24 bg-red p-7 text-white sm:p-10">
            <div className="flex items-baseline justify-between border-b border-white/25 pb-6">
              <h3 className="font-display text-2xl font-medium sm:text-3xl">{OWNER_PLAN.label}</h3>
            </div>
            <div className="pt-8">
              <ValueContrast value={OWNER_PLAN.value} price={OWNER_PLAN.price} dark onRed testId="owner-contrast" />
            </div>
            <BuyButton href={OWNER_PLAN.url} testId="owner-buy-button" variant="ink" className="mt-10 w-full">
              Wybieram ten abonament
            </BuyButton>
            <SaleNote dark />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
